import { lazy } from 'react'; // Dashboard
export const DashboardHighlights = lazy(() => import('@/Dashboard/DashboardHighlights'));
export const DashboardShopperHistory = lazy(() => import('@/Dashboard/DashboardShopperHistory'));
export const DashboardPromotionList = lazy(() => import('@/Dashboard/DashboardPromotionList'));
export const DashboardTraderList = lazy(() => import('@/Dashboard/DashboardTraderList'));
export const DashboardTraderListLiquor = lazy(() => import('@/Dashboard/DashboardTraderListLiquor'));
export const DashboardDemo = lazy(() => import('@/appshell/DemoPage'));
